import { GroupingError } from '@/store/modules/stay/types'

import { HospitalizationType } from '../types'

export interface Gme {
  reference: string
  description: string
  cm: string
  gn: string
  gr: string
  gl: string
  level: string
}

export interface SmrGroupingResult {
  id?: number | null
  value: number
  gme: Gme
  gmt: string
  groupingErrors?: GroupingError[] | null
}

export const defaultGme = (): Gme => {
  return {
    reference: '',
    description: '',
    cm: '',
    gn: '',
    gr: '',
    gl: '',
    level: ''
  }
}

export interface GroupingCardSmrProps {
  hospitalizationType: HospitalizationType
  groupingResult: SmrGroupingResult
  moneyGap?: number
  showValidator: boolean
}
